export const LOAD_SHARED_BLOCK = 'Casino/SharedBlock/LOAD_SHARED_BLOCK'
export const LOAD_SHARED_BLOCK_SUCCESS = 'Casino/SharedBlock/LOAD_SHARED_BLOCK_SUCCESS'
export const LOAD_SHARED_BLOCK_ERROR = 'Casino/SharedBlock/LOAD_SHARED_BLOCK_ERROR'
